import { RouteConfig } from "vue-router";
import { RCompanySummary } from "@/pages/Layout/views/Expert/views/Companies/template/views/Summary/RCompanySummary";
import { RCompanySponsorLicence } from "@/pages/Layout/views/Expert/views/Companies/template/views/SponsorLicence/RCompanySponsorLicence";
import { RCompanyDetails } from "@/pages/Layout/views/Expert/views/Companies/template/views/CompanyDetails/RCompanyDetails";
import { RCompanyDataHistory } from "@/pages/Layout/views/Expert/views/Companies/template/views/DataHistory/RCompanyDataHistory";
import { RCompanyEmployees } from "@/pages/Layout/views/Expert/views/Companies/template/views/Employees/RCompanyEmployees";
import { RCompanyDocuments } from "@/pages/Layout/views/Expert/views/Companies/template/views/Documents/RCompanyDocuments";
import { RCompanyServices } from "@/pages/Layout/views/Expert/views/Companies/template/views/Services/RCompanyServices";
import { RCompanyTasks } from "@/pages/Layout/views/Expert/views/Companies/template/views/Tasks/RCompanyTasks";

export const RCompaniesTemplate: RouteConfig = {
  path: ":company_id(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "companies-template" */
      "./VCompaniesTemplate.vue"
    ),
  meta: {
    title: "Companies",
  },
  children: [
    RCompanySummary,
    RCompanySponsorLicence,
    RCompanyDetails,
    RCompanyDocuments,
    RCompanyEmployees,
    RCompanyServices,
    RCompanyTasks,
    RCompanyDataHistory,
  ],
};
